import { ReactNode } from 'react';

import config from '../config';
import t from './i18n';
import HTTPError from './HTTPError';

export type ErrorInfo = {
    title: ReactNode,
    description: ReactNode
};

const handleError = (error: any, description?: string, title?: string): ErrorInfo => {
    if (config.development || config.test) {
        console.log('Error info:')
        console.log(window.location)
        console.log(window.history.state)
        console.log(error);

        if (config.test) {
            console.log(JSON.stringify(window.location));
            console.log(JSON.stringify(window.history.state));

            if (error && typeof error === 'object')
                console.log(JSON.stringify(error));
        }
    }

    if (error && error instanceof HTTPError) {
        const statusRange = `${error.response.status}`[0];

        title = title
            ? t(title)
        : statusRange === '4'
            ? t('Aviso')
        : statusRange === '5'
            ? t('Falha no servidor')
            : t('Erro inesperado');

        description = statusRange !== '5' && error.response.result?.message
            ? error.response.result.message
        : statusRange !== '5' && Array.isArray(error.response.result?.errors) && error.response.result.errors.length > 0
            ? (<>
                { error.response.result.errors.map((error, i) => (<p key={i}>{ error.message }</p>)) }
            </>)
        : description
            ? t(description)
            : t('Tente novamente mais tarde ou entre em contato conosco');
    } else {
        title = title ? t(title) : t('Erro inesperado');

        description = description ? t(description) : t('Tente novamente mais tarde ou entre em contato conosco');
    }

    return { title, description };
};

export default handleError;
